import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { UserContext, User } from "@/app/usercontext";
import { router } from "@/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/styles/app.css";

function parseJwt(token: string): any | null {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
}

const token = localStorage.getItem("token");
const payload = token ? parseJwt(token) : null;

const user: User | null = payload
    ? { name: payload.name, role: payload.role }
    : null;

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <UserContext.Provider value={user}>
            <RouterProvider router={router} />
        </UserContext.Provider>
    </React.StrictMode>
);